import React from "react";
import { useLocation } from "react-router-dom";
import { PathType } from "../paths/PathType";

import "./SidebarItem.css";
import { Text } from "grommet";

type SidebarItemProps = {
  item: PathType;
  onClickHandler: (path: string, submenu: boolean, menuName: string) => void;
};

function SidebarItem(props: SidebarItemProps) {
  const { onClickHandler, item } = props;
  const location = useLocation();

  return (
      <div
        className={location.pathname == item.path ? "sidebar-item-container sidebar-item-container-active" : "sidebar-item-container"}
        onClick={() => onClickHandler(item.path, true, "")}
      >
        <div
          className={
            location.pathname == item.path
              ? "sidebar-item-label-selected"
              : "sidebar-item-label"
          }
        >
          <img
            src={item.icon}
            style={{ display: "block" }}
          />
        </div>
        <Text
          className={
            location.pathname == item.path
              ? "menu-lable active-color"
              : "menu-lable"
          }
        >
          {item.label}
        </Text>
      </div>
  );
}

export default SidebarItem;
